import { connect } from 'react-redux';
import RemoveStep6 from './RemoveStep6';
import { removeBatchSequence } from '../../store/sequencingWizardSlice';

const mapDispatch = {
  removeBatchSequence,
};

export default connect(null, mapDispatch)(RemoveStep6);
